import React, { useState, useEffect } from "react";
import eligibility from "../../../../gql/eligibility";
import { useQuery } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/eligibility.css";
import "../../../Beneficiary/styles/BeneficiaryList.css";
import Details from "./components/Details";
import Coverages from "./components/Coverages";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  Box,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getColor } from "../../../PreAuth/components/response/ResponseDetailsComponentNew";
import EligibilityDetailsTable from "./EligibilityDetailsTable";
import { useTranslation } from "react-i18next";
import i18n from "../../../../i18n";
import AppButton from "../../../../shared/AppButton";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CustomFilterInput from "../../../../shared/CustomFilterInput";
import { FaPrint } from "react-icons/fa";

function EligibilityDetails({ helpDeskItem = null }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const item = location.state?.item ? location.state.item : helpDeskItem;
  const [currentTab, setCurrentTab] = useState("details");
  const [expanded, setExpanded] = useState(false);
  const [itemsData, setItemsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const { loading, error, data } = useQuery(
    eligibility.GET_TRANSACTION_DETAILS,
    {
      variables: {
        transactionId: item?.transaction_id,
      },
    },
  );

  const {
    data: itemsDataResponse,
    loading: itemsLoading,
    error: itemsError,
  } = useQuery(eligibility.GET_TRANSACTION_DETAILS_ITEMS, {
    skip: expanded !== "items",
    variables: {
      transactionId: item?.transaction_id,
    },
  });

  const items = [
    {
      in_force: "No",
      benefit_date: "2024-07-04 - 2025-01-21",
      member_id: "001007949538001",
      policy_number: "38946993",
      type: "extended healthcare",
      status: "active",
      relation_with_subscriber: "self",
      subscriber_member_id: "",
      network: "11-Network Gold",
      subrogation: null,
      site_eligibility: "eligible",
      class_name: "VIP",
      class_value: "VIP",
      class_type: "class",
      class_group_type: "group",
      class_group_name: "",
      class_group_value: "GHASSANCO",
      class_plan_name: "",
      class_plan_value: "38946993",
      class_plan_type: "plan",
      cost_to_ben_copay_type: "",
      cost_to_ben_copay_code: "",
      cost_to_ben_copay_value: 0,
      cost_to_ben_max_copay_type: "maxcopay",
      cost_to_ben_max_copay_value: 0,
      items: [
        {
          category_name: "Health Benefit Plan Coverage",
          description: "Health Benefit Plan Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Invented Medicines - with generic alternative",
          description:
            "OP Prescribed Invented Medicines - with generic alternative",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name: "Vision Coverage",
          description: "Vision Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Advanced Dental Coverage",
          description: "Advanced Dental Coverage with RCT",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1200, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Hospital Room and Board",
          description: "Hospital Room and Board",
          network: "in",
          unit: "individual",
          term: "day",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"room" } ] }, "allowedString":"NORMAL SUITE" }',
          ],
        },
        {
          category_name: "Basic and Preventive Dental Coverage",
          description: "Basic and Preventive Dental Coverage",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1800, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          description:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name: "Dental Coverage",
          description: "Dental Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Maternity",
          description: "Maternity.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Hospital Room and Board",
          description: "Hospital Room and Board",
          network: "in",
          unit: "individual",
          term: "day",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"room" } ] }, "allowedString":"NORMAL SUITE" }',
          ],
        },
        {
          category_name: "Advanced Dental Coverage",
          description: "Advanced Dental Coverage with RCT",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1200, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Health Benefit Plan Coverage",
          description: "Health Benefit Plan Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Dental Coverage",
          description: "Dental Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Basic and Preventive Dental Coverage",
          description: "Basic and Preventive Dental Coverage",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1800, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Vision Coverage",
          description: "Vision Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          description:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name:
            "OP Prescribed Invented Medicines - with generic alternative",
          description:
            "OP Prescribed Invented Medicines - with generic alternative",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
      ],
    },
    {
      in_force: "No",
      benefit_date: "2024-07-04 - 2025-01-21",
      member_id: "001007949538001",
      policy_number: "38946993",
      type: "extended healthcare",
      status: "active",
      relation_with_subscriber: "self",
      subscriber_member_id: "",
      network: "11-Network Gold",
      subrogation: null,
      site_eligibility: "eligible",
      class_name: "VIP",
      class_value: "VIP",
      class_type: "class",
      class_group_type: "group",
      class_group_name: "",
      class_group_value: "GHASSANCO",
      class_plan_name: "",
      class_plan_value: "38946993",
      class_plan_type: "plan",
      cost_to_ben_copay_type: "",
      cost_to_ben_copay_code: "",
      cost_to_ben_copay_value: 0,
      cost_to_ben_max_copay_type: "maxcopay",
      cost_to_ben_max_copay_value: 0,
      items: [
        {
          category_name: "Health Benefit Plan Coverage",
          description: "Health Benefit Plan Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Invented Medicines - with generic alternative",
          description:
            "OP Prescribed Invented Medicines - with generic alternative",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name: "Vision Coverage",
          description: "Vision Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Advanced Dental Coverage",
          description: "Advanced Dental Coverage with RCT",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1200, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Hospital Room and Board",
          description: "Hospital Room and Board",
          network: "in",
          unit: "individual",
          term: "day",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"room" } ] }, "allowedString":"NORMAL SUITE" }',
          ],
        },
        {
          category_name: "Basic and Preventive Dental Coverage",
          description: "Basic and Preventive Dental Coverage",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1800, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          description:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name: "Dental Coverage",
          description: "Dental Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Maternity",
          description: "Maternity.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Hospital Room and Board",
          description: "Hospital Room and Board",
          network: "in",
          unit: "individual",
          term: "day",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"room" } ] }, "allowedString":"NORMAL SUITE" }',
          ],
        },
        {
          category_name: "Advanced Dental Coverage",
          description: "Advanced Dental Coverage with RCT",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1200, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Health Benefit Plan Coverage",
          description: "Health Benefit Plan Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":10000, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Dental Coverage",
          description: "Dental Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Basic and Preventive Dental Coverage",
          description: "Basic and Preventive Dental Coverage",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"benefit" } ] }, "allowedMoney":{ "value":1800, "currency":"SAR" } }',
          ],
        },
        {
          category_name: "Vision Coverage",
          description: "Vision Coverage.",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"approval-limit" } ] }, "allowedMoney":{ "value":1, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
          ],
        },
        {
          category_name:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          description:
            "OP Prescribed Generic and Invented Medicines - with no generic alternative available",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
        {
          category_name:
            "OP Prescribed Invented Medicines - with generic alternative",
          description:
            "OP Prescribed Invented Medicines - with generic alternative",
          network: "in",
          unit: "individual",
          term: "lifetime",
          benefits: [
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-maximum" } ] }, "allowedMoney":{ "value":0, "currency":"SAR" } }',
            '{ "type":{ "coding":[ { "system":"http://nphies.sa/terminology/CodeSystem/benefit-type", "code":"copay-percent" } ] }, "allowedUnsignedInt":0 }',
          ],
        },
      ],
    },
  ];
  useEffect(() => {
    if (itemsDataResponse) {
      const coverages = items || [];
      const allItems = coverages.reduce((acc, coverage) => {
        return acc.concat(coverage.items || []);
      }, []);
      setItemsData(allItems);
    }
  }, [itemsDataResponse]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="superGit_container">
      <style>
        {`
          @media print {
            @page {
              size: A4 landscape;
              margin: 5mm; 
            }
            .no-print {
              display: none !important;
            }
            .print-only {
              display: block !important;
            }
            body {
              background-color: white !important;
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
            }
            /* Reset layout containers to allow full width without forcing block on all flex elements */
            #root, 
            .h-\\[calc\\(100vh-60px\\)\\],
            .superGit_container {
              width: 100% !important;
              max-width: 100% !important;
              padding: 0 !important;
              margin: 0 !important;
              height: auto !important;
              overflow: visible !important;
            }

            /* Ensure main wrappers don't clip content */
            .w-full.overflow-x-hidden {
              width: 100% !important;
              overflow: visible !important;
              display: block !important;
            }
            
            /* Table width fix */
            table {
              width: 100% !important;
              table-layout: auto !important;
              border-collapse: collapse !important;
            }

            /* Custom Margins for the print content */
            .superGit_container {
               padding: 10mm !important;
            }

            /* Ensure flex backgrounds and colors are preserved */
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
          .print-only {
            display: none;
          }
        `}
      </style>

      {/* Print-only heading */}
      <div
        className="print-only"
        style={{
          textAlign: "center",
          marginBottom: "30px",
          paddingBottom: "10px",
          borderBottom: "2px solid #333",
        }}
      >
        <Typography
          variant="h4"
          style={{
            fontWeight: "800",
            fontSize: "28px",
            color: "#1a202c",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          {t("Eligibility Details Report")}
        </Typography>
      </div>

      {/* Print Button Wrapper */}
      <div
        className="flex justify-end mb-1 no-print"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        <AppButton
          startIcon={<FaPrint style={{ fontSize: "12px" }} />}
          label={t("Print")}
          onClick={handlePrint}
        />
      </div>

      {currentTab === "details" && (
        <div>
          <Details
            item={data?.getVerificationTransaction?.data}
            transection_id={item?.transaction_id}
          />
          <Box className="my-1.5 px-1">
            <div className="flex justify-between items-center mb-1.5">
              <Typography
                className="flex gap-2 !font-bold !text-[18px] text-gray-800"
                variant="h6"
              >
                {t("Coverages")}
              </Typography>
            </div>
            <EligibilityDetailsTable
              items={data?.getVerificationTransaction?.data?.coverages}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />
          </Box>
        </div>
      )}
    </div>
  );
}

export default EligibilityDetails;
